// const saleArr = document.querySelectorAll(".sale-percentage");
// if (saleArr.length) {
// 	saleArr.forEach((el) => {
// 		const priceCurrent = Number(el.dataset.currentPrice);
// 		const priceMax = Number(el.dataset.maxPrice);
// 		if (priceCurrent !== priceMax) {
// 			const salePrice = 100 - (priceCurrent / priceMax) * 100;
// 			console.log(el.textContent, salePrice + "%");
// 			el.textContent = salePrice + "%";
// 		}
// 	});
// }

if (document.querySelector(".mkey-product-info")) {
	const thumbnailButtons = document.querySelectorAll(".mkey-thumbnail");
	const customSliderImages = document.querySelectorAll(".mkey-custom-slide");

	thumbnailButtons.forEach((el, ind) => {
		el.addEventListener("click", () => {
			customSliderImages[ind].scrollIntoView({
				block: "start",
				behavior: "smooth",
			});
		});
	});
}

const mkeyThumbnails = document.querySelector('.mkey-thumbnails');
if (mkeyThumbnails) {
  setTimeout(() => {
    mkeyThumbnails.style.opacity = '0';
  }, 3000)
}

function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

const safariVideos = [...document.querySelectorAll(".productMobileSwiper__slide video"), ...document.querySelectorAll(".mkey-custom-slide video")];
function setVideoControls() {
  if (isSafari() && safariVideos.length && window.innerWidth > 550) {
    safariVideos.forEach((el) => {
      el.setAttribute("controls", "true");
    });
  }
}
if (safariVideos) {
  setVideoControls();
}



const productCards = document.querySelectorAll('.mkey-gc');
if (productCards.length) {
  document.addEventListener("DOMContentLoaded", (event) => {
      productCards.forEach((card) => {
      const swiperContainer = card.querySelector('.swiper-init');
      const btnPrev = card.querySelector('.mkey-gc__btn-prev');
      const btnNext = card.querySelector('.mkey-gc__btn-next');
      const cardSlides = card.querySelectorAll('.mkey-gc__slide');
      const topBlock = card.querySelector('.mkey-gc__top');
    
      if (cardSlides.length <= 1) {
        if (btnPrev) btnPrev.style.display = 'none';
        if (btnNext) btnNext.style.display = 'none';
      }
    
      card.addEventListener('click', (event) => {
        if (
          event.target.closest('.mkey-gc__btn-prev') || 
          event.target.closest('.mkey-gc__btn-next') || 
          event.target.closest('.mkey-gc__variants')
        ) {
          return;
        }
        const url = card.dataset.productUrl;
        if (url) {
          window.location.href = url;
        }
      });
    
      [btnPrev, btnNext, card.querySelector('.mkey-gc__variants')].forEach((el) => {
        if (el) el.addEventListener('click', (event) => event.stopPropagation());
      });
    
      // if (swiperContainer) {
      //     const swiper = new Swiper(swiperContainer, {
      //       slidesPerView: 1,
      //       speed: 800,
      //       navigation: {
      //         nextEl: btnNext,
      //         prevEl: btnPrev,
      //       },
      //     });
      //     topBlock.addEventListener("mouseenter", () => {
      //       swiper.slideNext();
      //   });
      // }
    });
  });
}

// size guide popup
const sizeGuide = document.querySelector('.table-size__popup');
const sizeGuidePopup = document.querySelector('.size-guide__popup');
if (sizeGuide) {
  sizeGuide.addEventListener("click", (e) => {
    sizeGuidePopup.classList.add('active');
  })
    
  sizeGuidePopup.addEventListener("click", (e) => {
    // if (e.target === sizeGuidePopup) {
    //   sizeGuidePopup.classList.remove('active');
    // }
    sizeGuidePopup.classList.remove('active');
  })
}
// size guide popup

const productMetafieldTabs = document.querySelectorAll('.product-metafield__block');
if (productMetafieldTabs.length) {
  let currentActiveInd = null;
  productMetafieldTabs.forEach( (tab, ind, arr) => {
    tab.addEventListener("click", () => {
      if (currentActiveInd === null) {
        tab.classList.add("active");
      } else if (currentActiveInd === ind) {
        return false;
      } else {
        arr[currentActiveInd].classList.remove("active");
        tab.classList.add("active");
      }

      currentActiveInd = ind;
    })
  })
}


const swiper1 = new Swiper(".heroSwiper", {
	direction: "horizontal",
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
	},
	speed: 1200,
	slidesPerView: 1,
	spaceBetween: 0,
	loop: true,
});

var swiper2 = new Swiper(".threeItemsSwiper", {
	slidesPerView: 1,
	spaceBetween: 20,
	loop: true,
	navigation: {
		prevEl: ".threeItemsSwiper-prev",
		nextEl: ".threeItemsSwiper-next",
	},
	breakpoints: {
		601: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		1044: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
	},
});

const swiperHor = new Swiper(".collections-slider .swiper-container", {
	slidesPerView: 1,
	spaceBetween: 0,
    loop: true,
	mousewheel: {
		releaseOnEdges: true,
	},
	breakpoints: {
		601: {
			slidesPerView: 2,
		},
		1044: {
			slidesPerView: 3,
		},
	},
});

const productMobileSw = new Swiper(".productMobileSwiper", {
  pagination: {
    el: '.mk-swiper-scrollbar',
    type: "progressbar",
  },
});

if (document.querySelector('.main-hero')) {
  const heroTl = gsap.timeline({
	scrollTrigger: {
		trigger: ".main-hero",
      	start: "bottom bottom",
		end: "bottom 90%",
		scrub: true,
	},
});
heroTl
	.to(".main-hero__svg", {
		opacity: 0,
	})
	.from(
		".header__heading-logo-wrapper",
		{
			opacity: 0,
		},
		"<"
	);
}

